import React, { useState, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {usersByRole} from 'network/ApiAxios'
import Select from 'react-select';

function UserByRoleDropdownSele(props) {
    const toggle = () => props.toggle(!props.modal);
    
    useEffect(() => {
        retriveAllUser()
    }, [props.modal]);
    
    const [users, setUsers] = useState('');
    const [options, setOptions] = useState();

  
    const retriveAllUser= async()=>{
        if(props.modal){
            const resp = props.role ? await usersByRole(props.role) : await usersByRole()
            
            setUsers(resp.data)
            const opts = resp.data.map((user)=>{
              return {label:user.name, value: JSON.stringify({_id:user._id,name:user.name})}
              })
            setOptions(opts)
        }
    }
    
  return (
    <Modal isOpen={props.modal} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Choose Employee</ModalHeader>
        <ModalBody>
            <Select onChange={(e)=>{props.handler(e.value);toggle()}} options={options} />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
  )
}

export default UserByRoleDropdownSele